import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../../components/shared/Loader";
import { Link } from "react-router-dom";
import { updateMeta } from "../../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import { checkPermissions } from "../../../helpers/authentication/checkPermissions";

const ReasonsIndex = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "جميع أسباب العمل لدينا",
				breadcrumb: "التوظيف",
				button: {
					permissions: ["post-create"],
					show: true,
					text: "اضافة عنصر جديد",
					link: "/reasons/create",
				},
			})
		);

		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/strategies/all`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setData(response.data.data[0].categories[0].posts);
				setLoading(false);
			})
			.catch(function (error) {
				console.log(error);
				toast.error("خطأ، برجاء المحاولة لاحقا!");
				setLoading(false);
			});
	};

	const handleDelete = postID => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/posts/${postID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				onStart();
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<div className="row">
				{data.map(item => (
					<div className="col-md-3" key={item.id}>
						<div className="employees">
							{checkPermissions(["post-delete"]) && (
								<button onClick={() => handleDelete(item.id)}>
									<i className="fas fa-trash"></i>
								</button>
							)}
							<Link
								to={
									checkPermissions(["post-edit"])
										? `/reasons/show/${item.id}`
										: "/"
								}
							>
								<img
									src={`${process.env.REACT_APP_MAIN_URL}${item.data.icon}`}
									alt={item.data.title}
								/>
								<h4>{item.data.title}</h4>
							</Link>
						</div>
					</div>
				))}
			</div>
		</section>
	);
};

export default ReasonsIndex;
